/**
 * 生产环境对接的北京理工大学 LabVision 门户站点地址。
 * axios 生产拦截器、CAS、工作台跳转、静态资源等均基于此常量拼装。
 */

/** 站点根地址（scheme + host，无尾部斜杠） */
export const KFGX_API_ORIGIN = 'https://kfgx.bit.edu.cn/labvision-saas-api' // 开放共享系统的api接口
export const KFGX_SITE_ORIGIN = 'https://kfgx.bit.edu.cn/atc' // 开放共享系统门户的前端页面地址
export const WORKBENCH_SITE_ORIGIN = 'https://kfgx.bit.edu.cn' // 工作台地址（目前与前端页面地址相同，预留分离可能）



/** 生产环境后端 API 根路径 */
export const KFGX_API_BASE = `${KFGX_API_ORIGIN}`

/** CAS 登录成功回调地址（service 参数中的目标 URL） */
export const KFGX_CAS_LOGIN_SUCCESS_URL = `${KFGX_API_ORIGIN}/web/cas/login/success`

/** BIT 统一认证登录入口（跳转至 CAS，回调上述地址） */
export const BIT_CAS_LOGIN_WITH_KFGX_SERVICE = `https://login.bit.edu.cn/cas/login?service=${KFGX_CAS_LOGIN_SUCCESS_URL}`


/** 工作台（hash SPA） */
export const KFGX_WORKBENCH_URL = `${WORKBENCH_SITE_ORIGIN}/#/wel/main`

/** 机构端设备详情预约页（hash） */
export function kfgxOrgDeviceUrl(deviceId) {
  return `${WORKBENCH_SITE_ORIGIN}/#/org/device?id=${deviceId}`
}

/** 列表/详情缺省占位图 */
export const KFGX_DEVICE_PLACEHOLDER_IMAGE = `${WORKBENCH_SITE_ORIGIN}/images/bit/image/web/common/no_image.jpg`

/** 设备列表页横幅装饰图 */
export const KFGX_DEVICE_PAGE_BANNER_AVIF = `${WORKBENCH_SITE_ORIGIN}/images/bit/image/web/common/bit-device-sharing-banner-2.avif`

/** 帮助中心 PDF（路径含 URL 编码文件名） */
export const KFGX_HELP_MANUAL_URLS = {
  user: `${WORKBENCH_SITE_ORIGIN}/images/bit/help/%E5%A4%A7%E4%BB%AA%E5%85%B1%E4%BA%AB%E5%B9%B3%E5%8F%B0-%E7%94%A8%E6%88%B7%E4%BD%BF%E7%94%A8%E6%89%8B%E5%86%8C.pdf`,
  admin: `${WORKBENCH_SITE_ORIGIN}/images/bit/help/%E5%A4%A7%E4%BB%AA%E5%85%B1%E4%BA%AB%E5%B9%B3%E5%8F%B0-%E7%AE%A1%E7%90%86%E8%80%85%E4%BD%BF%E7%94%A8%E6%89%8B%E5%86%8C.pdf`,
  teacher: `${WORKBENCH_SITE_ORIGIN}/images/bit/help/%E5%A4%A7%E4%BB%AA%E5%85%B1%E4%BA%AB%E5%B9%B3%E5%8F%B0-%E6%95%99%E5%B8%88%E4%BD%BF%E7%94%A8%E6%89%8B%E5%86%8C.pdf`
}
